<template>
  <div class="payment-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t("general.action_record") }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            v-if="userType == 'super_admin'"
            slot="item-title"
            to="/super-admin/dashboard"
            >{{ $t("general.home") }}</router-link
          >
          <router-link
            v-else-if="userType == 'supplier'"
            slot="item-title"
            to="/supplier/dashboard"
            >{{ $t("general.home") }}</router-link
          >
          <router-link
            v-else-if="userType == 'anchor'"
            slot="item-title"
            to="/anchor/dashboard"
            >{{ $t("general.home") }}</router-link
          >
          <router-link
            v-else-if="userType == 'funder'"
            slot="item-title"
            to="/funder/dashboard"
            >{{ $t("general.home") }}</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link
            v-if="userType == 'super_admin'"
            slot="item-title"
            to="/super-admin/purchase-orders"
            >{{ $t("navigation.pos") }}</router-link
          >
          <router-link
            v-else-if="userType == 'supplier'"
            slot="item-title"
            to="/supplier/purchase-orders"
            >{{ $t("navigation.pos") }}</router-link
          >
          <router-link
            v-else-if="userType == 'anchor'"
            slot="item-title"
            to="/anchor/purchase-orders"
            >{{ $t("navigation.pos") }}</router-link
          >
          <router-link
            v-else-if="userType == 'funder'"
            slot="item-title"
            to="/funder/purchase-orders"
            >{{ $t("navigation.pos") }}</router-link
          >
        </li>
        <li class="breadcrumb-item">{{ $t("general.action_record") }}</li>
      </ol>
      <div class="page-actions row">
        <a
          v-if="invoiceType != 'preapproved'"
          :href="`/invoices/download_all_files/${invoiceUniqueHash}`"
          target="_blank"
          class="mr-3 invoice-action-btn base-button btn btn-outline-primary default-size"
          outline
          color="theme"
        >
          {{ $t("general.download_all_files") }}
        </a>
        <a
          v-else-if="
            invoiceType === 'preapproved' && userType === 'super_admin'
          "
          :href="`/invoices/download_all_files/${invoiceUniqueHash}`"
          target="_blank"
          class="mr-3 invoice-action-btn base-button btn btn-outline-primary default-size"
          outline
          color="theme"
        >
          {{ $t("general.download_all_files") }}
        </a>
        <a
          v-if="hasInvoiceAttachments && invoiceUniqueHash"
          :href="`/invoices/download_invoiceAttachment/${invoiceUniqueHash}`"
          target="_blank"
          class="mr-3 invoice-action-btn base-button btn btn-outline-primary default-size"
          outline
          color="theme"
        >
          {{ $t("general.download_invoice_attachments") }}
        </a>
        <a
          v-if="hasPOAttachments === true && invoiceUniqueHash"
          :href="`/invoices/download_poAttachment/${invoiceUniqueHash}`"
          target="_blank"
          class="mr-3 invoice-action-btn base-button btn btn-outline-primary default-size"
          outline
          color="theme"
        >
          {{ $t("general.download_po_attachments") }}
        </a>
      </div>
    </div>
    <SinglePurchaseOrderFinanceRow :fetchData="fetchData" />

    <table-component
      ref="table"
      :show-filter="false"
      :data="actionRecord"
      table-class="table"
    >
      <table-column
        :label="$t('invoices.date')"
        sort-as="invoice_date"
        show="formattedCreatedAt"
      />
      <table-column :label="$t('invoices.status')" sort-as="status">
        <template slot-scope="row">
          <span> {{ $t("invoices.status") }}</span>
          <span
            v-if="userType == 'anchor' && row.status == 'SENT'"
            :class="'inv-status-' + row.status.toLowerCase()"
            >{{ $t("general.received") }}</span
          >
          <span
            v-else-if="userType == 'anchor' && row.status != 'SENT'"
            :class="'inv-status-' + row.status.toLowerCase()"
            >{{
              row.status != "PARTIALLY_PAID"
                ? row.status
                : row.status.replace("_", " ")
            }}</span
          >
          <span
            v-else-if="userType != 'anchor'"
            :class="'inv-status-' + row.status.toLowerCase()"
            >{{
              row.status != "PARTIALLY_PAID"
                ? row.status
                : row.status.replace("_", " ")
            }}</span
          >
        </template>
      </table-column>
      <table-column :label="$t('general.company_name')">
        <template slot-scope="row">
          {{ row.company_name }}
        </template>
      </table-column>
    </table-component>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import MultiSelect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import SinglePurchaseOrderFinanceRow from "./SinglePurchaseOrderFinanceRow.vue";
export default {
  components: {
    MultiSelect,
    SinglePurchaseOrderFinanceRow
  },
  mixins: [validationMixin],
  data() {
    return {
      userType: null,
      fetchData: [],
      actionRecord: [],
      isLoading: false,
      invoiceUniqueHash: "",
      hasPOAttachments: false,
      hasInvoiceAttachments: false,
      invoiceType: null
    };
  },
  created() {
    if (localStorage.getItem("role") === "super_admin") {
      this.userType = "super_admin";
    } else if (localStorage.getItem("account_type") === "anchor") {
      this.userType = "anchor";
    } else if (localStorage.getItem("account_type") === "supplier") {
      this.userType = "supplier";
    } else if (localStorage.getItem("account_type") === "funder") {
      this.userType = "funder";
    }
    this.loadData();
    this.loadInvoice();
  },
  methods: {
    ...mapActions("po", ["SinglePOArray"]),
    async loadData() {},
    async loadInvoice() {
      let response = await this.SinglePOArray(this.$route.params.id);
      if (response.data) {
        this.invoiceUniqueHash = response.data.purchaseOrder[0]["unique_hash"];
        this.invoiceType = response.data.purchaseOrder[0]["invoice_type"];
        if (response.data.purchaseOrder[0]["media"].length > 0) {
          this.hasInvoiceAttachments = true;
        }
        if (
          response.data.purchaseOrder[0]["delivery_note"] &&
          response.data.purchaseOrder[0]["delivery_note"]["purchase_order"][
            "media"
          ].length > 0
        ) {
          this.hasPOAttachments = true;
        }
        this.fetchData = response.data.purchaseOrder;
        this.actionRecord = response.data.purchaseOrderActions;
      }
    }
  }
};
</script>
<style scoped>
.table-component {
  min-height: 0px !important;
}
</style>
